import { render, staticRenderFns } from "./NewContract.vue?vue&type=template&id=1a65eeec&scoped=true&"
import script from "./NewContract.vue?vue&type=script&lang=js&"
export * from "./NewContract.vue?vue&type=script&lang=js&"
import style0 from "./NewContract.vue?vue&type=style&index=0&id=1a65eeec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a65eeec",
  null
  
)

export default component.exports